<template>
	<div class="detail_body">
		<div class="coll">
			<h2 class="title"><span>基本信息</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
						<th>客户编码</th><td>{{sdata.customerCode}}</td>
						<th>客户描述</th><td>{{sdata.customerName}}</td>
					</tr>
          <tr>
            <th>增值税登记号</th><td colspan="3">{{sdata.vatRegiNum}}</td>
          </tr>
				</table>
			</div>
		</div>

    <div class="coll">
      <h2 class="title"><span>联系信息</span></h2>
      <div class="cons">
        <table class="tab_detail">
          <tr>
            <th>联系人</th><td>{{sdata.contact}}</td>
            <th>联系电话</th><td>{{sdata.telephone}}</td>
          </tr>
          <tr>
            <th>电子邮件</th><td colspan="3">{{sdata.email}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="coll">
      <h2 class="title"><span>地址</span></h2>
      <div class="cons">
        <table class="tab_detail">
          <tr>
            <th>地区</th><td>{{sdata.proviceDesc}} {{sdata.cityDesc}} {{sdata.countyDesc}}</td>
            <th>详细地址</th><td>{{sdata.streetAdress}}</td>
          </tr>
          <tr>
            <th>邮编</th><td>{{sdata.zipCode}}</td>
            <th>国家代码</th><td>{{sdata.countryCode}}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="coll">
      <h2 class="title"><span>其他信息</span></h2>
      <div class="cons">
        <table class="tab_detail">
          <tr>
            <th>创建人员</th><td>{{sdata.createUserName}}</td>
            <th>更改人员</th><td>{{sdata.modifyUserName}}</td>
          </tr>
          <tr>
            <th>上次更改日期</th><td colspan="3">{{sdata.lastModifyDate}}</td>
          </tr>
        </table>
      </div>
    </div>

		<div class="coll">
			<h2 class="title"><span>其他信息</span></h2>
			<div class="cons">
				<table class="tab_detail">
					<tr>
            <th>创建人</th><td>{{sdata.createUserName}}</td>
						<th>创建日期</th><td>{{sdata.createDate}}</td>
					</tr>
          <tr>
            <th>更改人员</th><td>{{sdata.modifyUserName}}</td>
            <th>上次更改日期</th><td>{{sdata.lastModifyDate}}</td>
          </tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default{
  props:{
    sdata:Object
  },
	created(){

	},
	methods:{
	}
}
</script>
